import { __extends } from "tslib";
import BSSAbstractComponent from '../../bss-abstract-component/js/bss-abstract-component.js';
import checkboxSwitchTemplate from '../template/checkbox--switch.hbs';
import { isEmpty } from 'lodash';
var checkboxTemplates = {
    checkboxSwitchTemplate: checkboxSwitchTemplate
};
var BSSCheckboxProductTypeSwitchComponent = /** @class */ (function (_super) {
    __extends(BSSCheckboxProductTypeSwitchComponent, _super);
    /**
     *
     * @param {String} [_entityTemplate=null] _entityTemplate entity template
     * @param {String} [containerSelector=null] containerSelector component container selector
     * @param {Object} [config=null] config configuration of component
     * @param {EventManager} [EventManager=null] instance of _EventManager
     * @param {Formatter} [Formatter=null] instance of Formatter
     * @param {Resolution} [Resolution=null] Resolution class for width breakpoint handling
     * @param {object} [toolbox=null] provides common libraries: jquery and lodash
     */
    function BSSCheckboxProductTypeSwitchComponent(_entityTemplate, containerSelector, config, eventManager, formatter, resolution, toolbox) {
        if (_entityTemplate === void 0) { _entityTemplate = null; }
        if (containerSelector === void 0) { containerSelector = null; }
        if (config === void 0) { config = null; }
        if (eventManager === void 0) { eventManager = null; }
        if (formatter === void 0) { formatter = null; }
        if (resolution === void 0) { resolution = null; }
        if (toolbox === void 0) { toolbox = null; }
        var _this = _super.call(this, _entityTemplate, containerSelector, config, eventManager, formatter, resolution, checkboxTemplates, toolbox) || this;
        _this._setDefaults();
        _this._setTitle();
        return _this;
    }
    /**
     * @desc set switch defaults
     * @private
     */
    BSSCheckboxProductTypeSwitchComponent.prototype._setDefaults = function () {
        this._$input = this._$componentEl.find('.bss-switch-checkbox_cxb') || null;
        this._$labelValue = this._$componentEl.find('.bss-switch-checkbox_title value') || null;
    };
    /**
     * @desc set title for switch label
     * set title for switch label as component is rendered outside of entity flow binding/ ui-description
     * @private
     */
    BSSCheckboxProductTypeSwitchComponent.prototype._setTitle = function () {
        var _a;
        var configTitle = this._config.title || null;
        if (isEmpty(this._config.texts)) {
            this._config.texts = this._toolbox.layoutTexts || {};
        }
        // no need to refresh a whole template, we set only title value
        if ((configTitle === null || configTitle === void 0 ? void 0 : configTitle.indexOf('data-text')) !== -1 && Object.keys(this._config.texts).length) {
            (_a = this._$labelValue) === null || _a === void 0 ? void 0 : _a.text(this._getBoundedString(configTitle));
        }
    };
    /**
     * @desc set checkbox state
     * @param {boolean} checked checkbox state
     * @private
     */
    BSSCheckboxProductTypeSwitchComponent.prototype._setState = function (checked) {
        var _a;
        if (checked === void 0) { checked = false; }
        if ((_a = this._$input) === null || _a === void 0 ? void 0 : _a.length) {
            this._$input.removeClass('is-checked');
            if (checked) {
                this._$input.addClass('is-checked');
            }
        }
    };
    return BSSCheckboxProductTypeSwitchComponent;
}(BSSAbstractComponent));
export default BSSCheckboxProductTypeSwitchComponent;
